import React from "react";
import { useTranslation } from "react-i18next";
import "./Reviews.css";
import Card from "./card/Card";
import ScrollableCardContainer from "./GenricScrollbar";

const Reviews = ({ reviews }) => {
  const { t } = useTranslation("place");
 console.log(reviews);

  return (
    <div className={"reviews"}>
      <h3>{t("Reviews.title")}</h3>
      {reviews?.data?.length > 0 ? (
        <ScrollableCardContainer>
          {reviews?.data?.map((review, index) => (
            <Card
              image={review.user.image}
              review={review.message}
              key={index}
              rating={review.rating}
              name={review.user.fullName}
              role={review.user.company}
            />
          ))}
        </ScrollableCardContainer>
      ) : (
        <p>{t("Reviews.noReviews", { message: reviews?.message })}</p>
      )}
    </div>
  );
};

export default Reviews;
